import script from "./QualificationRequirementSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./QualificationRequirementSection.vue?vue&type=script&setup=true&lang=ts"

import "./QualificationRequirementSection.vue?vue&type=style&index=0&id=2a570c24&lang=css"

const __exports__ = script;

export default __exports__